import React from "react";
import ServiceCard from './ServiceCard';
import ServiceModal from "../../components/microsite/ServiceModal";
import { useServiceModal } from '../../hooks/useServiceModal';
import { Service } from "../../types/service";

interface MicrositeServiceSectionProps {
  themeColor?: string;
  services: Service[];
}

const MicrositeServiceSection: React.FC<MicrositeServiceSectionProps> = ({
  themeColor = "#885ABB",
  services,
}) => {
  const { selectedService, isOpen, openModal, closeModal } = useServiceModal();

  return (
    <div  className="py-24 bg-white text-gray-800 font-serif">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 font-serif mb-3">Our Services.</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover premium salon experiences tailored to your personality and lifestyle.
          </p>
        </div>

        {services.length > 0 ? (
          services.map((service,idx) => (
            <ServiceCard
              index={idx+1}
              service={service}
              themeColor={themeColor}
              onViewDetails={openModal}
            />
          ))
        ) : (
          <p className="text-center text-gray-400">No services available yet.</p>
        )}

        {selectedService && (
          <ServiceModal open={isOpen} onClose={closeModal} service={selectedService} themeColor={themeColor}/>
        )}
      </div>
      </div>
  );
};

export default MicrositeServiceSection;
